import React from "react";
import nextId from "react-id-generator";
import { Link, useHistory } from "react-router-dom";
import { updateCandidatePreference } from "../../../../APIs/PostAPIS";
import CustomCheckBox from "../../../Common/CustomCheckbox/CustomCheckBox";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import Notification from "../../../Portals/Notification/Notification";
import "./preference.style.scss";
export default function PreferenceComponent({
  changeRoute,
  currentRoute,
  setNotification,
  completeIt,
}) {
  const history = useHistory();
  const context = React.useContext(MainContext);
  const [error, setError] = React.useState(false);
  const { userDetails, initialChecking, registrationStep, updateState } =
    context;
  const [loading, setLoading] = React.useState(false);
  const [preferenceDetails, setPreferenceDetails] = React.useState({
    candidate_expected_salary: "",
    candidate_location: [],
    candidate_relocate: false,
    candidate_coaching: false,
  });
  const handleSkip = () => {
    let temp = [...registrationStep];
    temp[3] = { ...temp[3], skipped: true };
    updateState("registrationStep", [...temp]);
    changeRoute();
    history.push("/register/resume");
  };
  const clearNotification = () => {
    history.push("/register/resume");
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      changeRoute();
      setLoading(false);
      clearTimeout(a);
    }, [3000]);
  };
  const handleUpdate = async () => {
    setLoading(true);
    try {
      let res = await updateCandidatePreference({ ...preferenceDetails });
      if (!res.data.error) {
        completeIt()
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
        initialChecking();
        clearNotification();
      } else {
      }
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    let temp = {
      candidate_expected_salary: userDetails.candidate_expected_salary,
      candidate_location: userDetails.candidate_location,
      candidate_relocate:
        userDetails.candidate_relocate === undefined
          ? false
          : userDetails.candidate_relocate,
      candidate_coaching:
        userDetails.candidate_coaching === undefined
          ? false
          : userDetails.candidate_coaching,
    };
    setPreferenceDetails({ ...temp });
  }, []);
  const handleLocation = (location) => {
    let temp = preferenceDetails.candidate_location.filter((obj) => {
      return obj.location_name !== location.location_name;
    });
    setPreferenceDetails({
      ...preferenceDetails,
      candidate_location: [...temp],
    });
  };

  const validations = () => {
    if (preferenceDetails.candidate_relocate) {
      let check =
        !preferenceDetails.candidate_expected_salary ||
        !preferenceDetails.candidate_location.length;
      setError(check);
      return check;
    } else {
      let check = !preferenceDetails.candidate_expected_salary;
      setError(check);
      return check;
    }
  };

  React.useEffect(() => {
    currentRoute();
  }, []);
  return (
    <div className="preference-component">
      <header className="pc-header">
        <p>Step 4. Your Preferences</p>
      </header>
      <div className="pc-body">
        <div
          className={`fancy-input ${
            error && !preferenceDetails.candidate_expected_salary ? "error" : ""
          }`}
        >
          <span>Expected Salary*</span>
          <input
            value={preferenceDetails.candidate_expected_salary}
            placeholder="80000"
            onChange={(e) =>
              setPreferenceDetails({
                ...preferenceDetails,
                candidate_expected_salary: e.target.value,
              })
            }
          />
        </div>
        <CustomCheckBox
          handleChange={(obj) =>
            setPreferenceDetails({
              ...preferenceDetails,
              candidate_relocate: obj.id,
            })
          }
          selected={preferenceDetails.candidate_relocate}
          title="Ready To Relocate*"
          list={list}
        />

        {preferenceDetails.candidate_relocate && (
          <div
            className={`skills-list ${
              error && !preferenceDetails.candidate_location.length
                ? "error-skill"
                : ""
            }`}
          >
            <span className="sl-title">Preferred location*</span>
            {preferenceDetails.candidate_location.map((obj) => (
              <button>
                {obj.location_name}
                <span onClick={() => handleLocation(obj)}>x</span>
              </button>
            ))}

            <input
              onKeyPress={(e) => {
                if (e.which === 13 || e.which === 32) {
                  setPreferenceDetails({
                    ...preferenceDetails,
                    candidate_location: [
                      ...preferenceDetails.candidate_location,
                      {
                        location_name: e.target.value,
                        sub_location_name: "",
                      },
                    ],
                  });
                  e.target.value = "";
                }
              }}
              autoFocus
              placeholder="+ Add location"
            />
          </div>
        )}

        <CustomCheckBox
          handleChange={(obj) =>
            setPreferenceDetails({
              ...preferenceDetails,
              candidate_coaching: obj.id,
            })
          }
          selected={preferenceDetails.candidate_coaching}
          title="Prefer Online Coaching*"
          list={list}
        />
      </div>
      <div className="pc-footer">
        <button onClick={() => handleSkip()}>Skip Step</button>
        <button
          onClick={() => (validations() ? console.log() : handleUpdate())}
        >
          {loading ? "Updating...." : "Update"}
        </button>
      </div>
    </div>
  );
}
const list = [
  { keyId: nextId(), name: "Yes", id: true },
  { keyId: nextId(), name: "No", id: false },
];
